import type {AppraiserRepository} from '@/domain/interfaces/AppraiserRepository';

export class GetAllAppraisersUseCase {
  constructor(private readonly appraiserRepository: AppraiserRepository) {}
  async execute() {
    return this.appraiserRepository.getAll();
  }
}
